import StockRemove from "./StockRemove";

export {StockRemove}
export default StockRemove
